const name = 'counterExample'
export default name
